import {
  PayoutStatus,
  useApproveFundingMutation,
  useRejectFundingMutation,
} from "@/api/admin/fundings";
import { QUERY_KEYS } from "@/api/constants";
import { queryClient } from "@/api/queryClient";
import { toastError, toastSuccess } from "@/components/molecules";

export const useUpdateApplicationStatus = (
  id: string,
  queryKey?: string | string[]
) => {
  const { mutate: approveApplication, isPending: isPendingApprove } =
    useApproveFundingMutation();

  const { mutate: rejectApplication, isPending: isPendingReject } =
    useRejectFundingMutation();

  const handleChangeStatus = (status: PayoutStatus) => {
    const options = {
      onSuccess: () => {
        if (queryKey) {
          const keys = Array.isArray(queryKey) ? queryKey : [queryKey];
          keys.forEach(key => {
            queryClient.invalidateQueries({
              queryKey: [key],
            });
          });
        } else {
          queryClient.invalidateQueries({
            queryKey: [QUERY_KEYS.brandFundingApplication],
          });
        }

        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.brandFundingApplication, id],
        });

        toastSuccess(`Application successfully ${status.toLowerCase()}`);
      },
      onError: (error: Error) => {
        toastError(error.message, () => handleChangeStatus(status), "Error");
      },
    };

    if (status === PayoutStatus.APPROVED) {
      approveApplication(id, options);
      return;
    }

    if (status === PayoutStatus.DECLINED) {
      rejectApplication(id, options);
    }
  };

  return {
    handleChangeStatus,
    isPending: isPendingApprove || isPendingReject,
  };
};
